import { createVuetify } from "vuetify";
import "@/styles/main.scss";
import { aliases, fa } from "vuetify/iconsets/fa-svg";
import { mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";

const nclLightTheme = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#7CB5EC",
    "primary-darken-1": "#4578c6",
    secondary: "#FFA500",
    "secondary-darken-1": "#f77900",
    error: "#bc1d10",
    info: "#c2def7",
    success: "#00736b",
    warning: "#fc8a00",
  },
};

const nclDarkTheme = {
  dark: true,
  colors: {
    background: "#1E1E1E",
    surface: "#2D2D2D",
    primary: "#7CB5EC",
    "primary-darken-1": "#4578c6",
    secondary: "#FFA500",
    "secondary-darken-1": "#f77900",
    error: "#ff5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
};

const savedTheme = (() => {
  try {
    return localStorage.getItem("theme");
  } catch {
    return null;
  }
})();

const prefersDark =
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

const initialTheme =
  savedTheme === "nclDarkTheme" || savedTheme === "nclLightTheme"
    ? savedTheme
    : prefersDark
      ? "nclDarkTheme"
      : "nclLightTheme";

export default createVuetify({
  theme: {
    defaultTheme: initialTheme,
    themes: {
      nclLightTheme,
      nclDarkTheme,
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      fa,
      mdi,
    },
  },
});
